module.exports = __webpack_public_path__ + "img/imagem10.64983071.svg";